<template>
<v-form ref="form" class="mx-2" method="post" enctype="multipart/form-data">
  <v-container
    id="UBICAZIONI"
    fluid
    tag="section"
  >
    <v-row>
        <v-col :cols="isEditUbicazioni ? '4' : '12'">
          <base-material-card
            color="white"
            iconcolor="darkred"
            icon="mdi-earth-arrow-right"
            :title="$t('ubicazioni.titolo')"
            class="px-5 py-3"
          >
            <v-container v-if="isCreatedCorrectly" v-resize="onContainerChange">
              <v-row>
                <v-col>
                  <v-card-title>
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      :label="$t('ubicazioni.ricerca')"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>
                </v-col>
                <v-col align="end">
                  <v-btn color="darkred" width="150px" @click="onNuovaUbicazione">
                    <v-icon left> mdi-plus-circle-outline </v-icon>
                    {{ $t("ubicazioni.nuovaUbicazione") }}
                  </v-btn>
                  <v-btn color="darkred" width="180px" @click="onExportGrid" v-show="false">
                    <v-icon left> mdi-export </v-icon>
                    {{ $t("esporta") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
            <v-data-table
              style="max-height:600px; overflow:auto"
              id="tblUbicazioni"
              :items="ubicazioni.source"
              :headers="headersColumns"
              :search="search"
              :value="[ubicazioni.selected]"
              @click:row="onTableRowClick"
              single-select
              :items-per-page="-1"
              class="elevation-1"
              :loading="isloading_dataTable"
              loading-text="Caricamento dati in corso..."
            >
            </v-data-table>
          </base-material-card>
        </v-col>

        <v-col v-if="isEditUbicazioni" cols="8">
          <base-material-card
            color="white"
            iconcolor="darkred"
            icon="mdi-earth"
            :title="$t('ubicazioni.ubicazione') + ': ' + ubicazioni.selected.cDescrizione"
            class="px-5 py-3"
          >
            <v-card flat>
              <v-row>
                <v-card-title
                  class="black--text"
                  style="margin-bottom: 20px; margin-top: 20px"
                  >{{ $t("anagrafica") }}
                </v-card-title>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="ubicazioni.selected.cDescrizione"
                    :label="$t('ubicazioni.descrizioneObbl')"
                    :rules="[rules.required]"
                    maxlength="50"
                    :disabled="shouldDisable"
                  >
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="ubicazioni.selected.cIndirizzo"
                    :label="$t('ubicazioni.indirizzoObbl')"
                    :rules="[rules.required]"
                    maxlength="100"
                    :disabled="shouldDisable"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-select
                    :items="eEnti"
                    return-object
                    item-text="cDescrizione"
                    item-value="id"
                    :label="$t('ubicazioni.enteObbl')"
                    :rules="[rules.selectRequired]"
                    v-model="ubicazioni.selected.enteDTO"
                    :disabled="shouldDisable"
                    @change="onEnteChanged($event)"
                  >
                  </v-select>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="ubicazioni.selected.cTelefono"
                    :label="$t('ubicazioni.telefonoObbl')"
                    :rules="[rules.required]"
                    maxlength="50"
                    :disabled="shouldDisable"
                  >
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="ubicazioni.selected.cEmail"
                    :label="$t('ubicazioni.emailObbl')"
                    :rules="[rules.required]"
                    maxlength="50"
                    :disabled="shouldDisable"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row> </v-row>

              <v-divider class="mx-4"></v-divider>
              <v-row
                style="margin-top: 20px; margin-left: 20px; margin-bottom: 10px"
              >
                <v-alert
                  id="alertDettaglio"
                  shaped
                  :value="isAlertDetailVisible"
                  :type="alertType"
                  dismissible
                >
                  {{ messaggioAlert }}
                </v-alert>
              </v-row>

              <v-row
                style="margin-top: 20px; margin-left: 20px; margin-bottom: 10px"
              >
                <v-btn
                  tile
                  color="darkred"
                  v-if="!isHidden"
                  v-on:click="isHidden = true"
                  @click="onEditClick"
                >
                  <v-icon left> mdi-pencil </v-icon>
                  {{ $t("modifica") }}
                </v-btn>
                <v-btn
                  tile
                  color="darkred"
                  v-if="isHidden"
                  @click="onSaveClick"
                >
                  <v-icon left> mdi-content-save </v-icon>
                  {{ $t("salva") }}
                </v-btn>
                <v-btn tile color="darkred" @click="onDisattivaClick">
                  <v-icon left> mdi-delete </v-icon>
                  {{ $t("disattiva") }}
                </v-btn>
                <v-btn
                  id="btnChiudi"
                  tile
                  color="darkred"
                  @click="onCloseDetail"
                >
                  <v-icon left> mdi-door-open </v-icon>
                  {{ $t("chiudi") }}
                </v-btn>
                <v-dialog v-model="dialogDisattivaUbicazione" max-width="500px">
                  <v-card>
                    <v-card-title class="text-h5"
                      >Sei sicuro di voler disattivare l'ubicazione selezionata?
                    </v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="onCloseDisattivaUbicazione"
                        >Annulla</v-btn
                      >
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="onConfirmDisattivaUbicazione"
                        >OK</v-btn
                      >
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
            </v-card>
          </base-material-card>
        </v-col>
      </v-row>

      <v-row>
        <v-alert
          id="alertGrid"
          shaped
          :value="isAlertGridVisible"
          :type="alertType"
          dismissible
        >
          {{ messaggioAlert }}
        </v-alert>
      </v-row>
  </v-container>
  </v-form>
</template>

<script>
import Vue from "vue";
import Component from "vue-class-component";

import i18n from "@/i18n";
import Utils from "@/utils/Utils";

import TipologicheService from "@/service/TipologicheService";
import EntiService from "@/service/EntiService";
import CapitoliService from "@/service/CapitoliService";
import UbicazioniService from "@/service/UbicazioniService";
import UtentiService from "@/service/UtentiService";

@Component
export default class Ubicazioni extends Vue {

  ubicazioni = {
    selected: null,
    source: [],
  };

  headersColumns = [
    
    { text: "Descrizione", value: "cDescrizione", align: "start"  },
    { text: "Indirizzo", value: "cIndirizzo" },
    { text: "Telefono", value: "cTelefono" },
    { text: "E-mail", value: "cEmail" },
    { text: "Ente", value: "enteDTO.cDescrizione" },
  ];

  eEnti = [];

  isEditUbicazioni = false;
  isNewUbicazione = false;
  isCreatedCorrectly = false;
  isAlertGridVisible = false;
  isAlertDetailVisible = false;
  isloading_dataTable = false;
  shouldDisable = true;
  enteShouldDisable = true;
  isHidden = false;
  saveClicked = false;
  isNewUser = false;
  dialogDisattivaUbicazione = false;

  ubicazioneTemplate = null;

  dimension = 0;

  messaggioAlert = "";
  alertType = "error";
  search = "";

  rules = Utils.rules;

  created() {
    let verLoadingPage = Utils.verifyLoadingPage(
      this.$store,
      "W_PROFILAZIONEUTENTE"
    );
    switch (verLoadingPage) {
      case 0: // All OK
        this.isCreatedCorrectly = true;
        var enteId = this.$store.state.enteSel.id;

        this.loadUbicazioni(0);
        this.loadEnti();
        this.getTemplateUbicazione();
        break;

      case 1: // Utente non loggato
        AuthService.logout();
        break;

      case 2: // Ente non selezionato
        this.$router.push({ name: "Dashboard" });
        break;

      case 3: // Permesso alla pagina non presente
        this.$router.push({ name: "Dashboard" });
    }
  }

  onEditClick() {
    this.shouldDisable = false;
  }

  onDisattivaClick() {
    this.dialogDisattivaUbicazione = true;
  }

  onSaveClick() {
    // Verifico se i campi della form sono tutti validi.
    // Per funzionare nel template ci deve essere un oggetto di tipo V-FORM
    this.saveClicked = true;
    var formIsValid = this.$refs.form.validate();
    if (!formIsValid) {
      this.alertType = "error";
      // In caso di errore del salvataggio continuare con l'editing
      this.messaggioAlert = i18n.t("erroreCampiObbligatori");
      this.showHide_alertDetail(8000);
    } else {
      if (this.ubicazioni.selected.id > 0) {
        // Salvo il dato sul DB
        this.saveUbicazioneDto(this.ubicazioni.selected.id);
      } else {
        // Creo il nuovo record
        this.createUbicazioneDto();
      }
    }
  }

  onCloseDetail() {
    this.isEditUbicazioni = false;
    this.onContainerChange();
    this.shouldDisable = true;
    this.isHidden = false;
  }

  onExportGrid() {
    // TODO
  }

  onNuovaUbicazione() {
    this.saveClicked = false;
    this.isNewUbicazione = true;
    this.isEditUbicazioni = true;
    this.shouldDisable = false;
    this.isHidden = true;

    this.ubicazioni.selected = Object.assign({}, this.ubicazioneTemplate);

    this.onContainerChange();

    //this.manageEntiVisibility(true);

    this.onEnteChanged();

    this.$refs.form.resetValidation();
  }

  onTableRowClick(ubicazioneSel) {
    // Setto la riga selezionata
    this.ubicazioni.selected = ubicazioneSel;

    console.log("Ubicazione selezionato: ");
    console.log(this.ubicazioni.selected);

    //this.manageEntiVisibility(false);
    // TODO
    this.onEnteChanged();

    this.isHidden = false;
    this.shouldDisable = true;
    this.isEditUbicazioni = true;
  }

  onContainerChange() {
    let self = this;
    // console.log("onContainerChange");
    self.$nextTick(function () {
      self.dimension = document.getElementById("tblUbicazioni").offsetWidth;
      return self.dimension;
    });
  }

  onCloseDisattivaUbicazione() {
    this.dialogDisattivaUbicazione = false;
  }

  onEnteChanged() {
    if (
      !Utils.isNullOrUndefined(this.ubicazioni.selected.enteDTO) &&
      this.ubicazioni.selected.enteDTO.id != -1
    ) {
      // Carico gli utenti
      // this.loadUtenti(this.ubicazioni.selected.enteDTO.id);
    }
  }

  onConfirmDisattivaUbicazione() {
    this.disattivaUbicazioneDto(this.ubicazioni.selected.id);
    this.dialogDisattivaUbicazione = false;
  }

  showHide_alertGrid(millisecondInterval, event) {
    //console.log('Hide alert');
    this.isAlertGridVisible = true;
    // `event` is the native DOM event
    window.setTimeout(() => {
      this.isAlertGridVisible = false;
      console.log(
        "hide alert after " + millisecondInterval / 1000 + " seconds"
      );
    }, millisecondInterval);
  }

  showHide_alertDetail(millisecondInterval, event) {
    //console.log('Hide alert');
    this.isAlertDetailVisible = true;
    // `event` is the native DOM event
    window.setTimeout(() => {
      this.isAlertDetailVisible = false;
      //console.log("hide alert after " + millisecondInterval/1000 + " seconds");
    }, millisecondInterval);
  }

  /// ***********************
  /// DATABASE
  /// ***********************

  getTemplateUbicazione() {
    var self = this;

    UbicazioniService.getTemplateUbicazione(
      (resp) => {
        console.log("getTemplateUbicazione:");
        console.log(resp);

        self.ubicazioneTemplate = resp;
      },
      (err) => {
        console.log(err);
        self.alertType = "error";
        self.messaggioAlert = Utils.getErrorMessage(err);
        self.showHide_alertDetail(8000);
      }
    );
  }

  loadUbicazioni(enteId, storico) {
    var self = this;
    self.isloading_dataTable = false;
    UbicazioniService.getUbicazioni(
      enteId,
      (resp) => {
        console.log("getUbicazioni");
        console.log(resp);

        self.ubicazioni.source = resp;
        self.isloading_dataTable = false;
      },
      (err) => {
        console.log("Errore getUbicazioni");
        console.log(err);
        self.isloading_dataTable = false;
      }
    );
  }

  loadEnti() {
    var self = this;

    EntiService.getEnti(
      (resp) => {
        console.log("GetEnti");
        console.log(resp);

        self.eEnti = resp;
      },
      (err) => {
        console.log("Errore GetEnti");
        console.log(err);
      }
    );
  }

  loadUtenti(enteId) {
    var self = this;
    UtentiService.getUsersEnti(
      enteId,
      (resp) => {
        console.log("GetUtenti");
        console.log(resp);

        self.eUtenti = resp;
      },
      (err) => {
        console.log("Errore GetUtenti");
        console.log(err);
      }
    );
  }

  saveUbicazioneDto(id) {
    var self = this;

    UbicazioniService.updateUbicazione(
      self.ubicazioni.selected,
      (resp) => {
        console.log("updateUbicazione");
        console.log(resp);
        if (resp.result == 1) {
          // Buon fine
          self.alertType = "success";
          self.messaggioAlert = resp.userMsg.message;
          self.showHide_alertDetail(5000);
          // Aggiorno la griglia principale
          self.updateGridUbicazione(id);
        } else {
          // KO
          self.alertType = "error";
          self.messaggioAlert = resp.userMsg.message;
          self.showHide_alertDetail(8000);
        }

        self.isHidden = !self.isHidden;
        self.shouldDisable = true;
        console.log(resp.userMsg.message);
      },
      (err) => {
        console.log(err);
        self.alertType = "error";
        self.messaggioAlert = Utils.getErrorMessage(err);
        self.showHide_alertDetail(8000);
      }
    );
  }

  createUbicazioneDto() {
    var self = this;

    UbicazioniService.createUbicazione(
      self.ubicazioni.selected,
      (resp) => {
        console.log("createUbicazione");
        console.log(resp);
        if (resp.result == 1) {
          // Buon fine
          self.alertType = "success";
          self.messaggioAlert = resp.userMsg.message;
          self.showHide_alertGrid(5000);
          // Aggiorno la griglia principale
          self.updateGridUbicazione(resp.idNewObject);
          self.isNewServizio = false;
        } else {
          // KO
          self.alertType = "error";
          self.messaggioAlert = resp.userMsg.message;
          self.showHide_alertDetail(8000);
        }

        self.isHidden = !self.isHidden;
        self.shouldDisable = true;
        console.log(resp.userMsg.message);
      },
      (err) => {
        console.log(err);
        self.alertType = "error";
        self.messaggioAlert = Utils.getErrorMessage(err);
        self.showHide_alertDetail(8000);
      }
    );
  }

  updateGridUbicazione(id, onSuccess) {
    var self = this;

    UbicazioniService.getUbicazione(
      id,
      (resp) => {
        console.log("Ubicazione:");
        console.log(resp);

        var ubicazioneTmp = resp;

        if (typeof onSuccess === "function") onSuccess(resp);
        // Aggiorno la griglia
        var found = false;
        for (let i = 0; i < self.ubicazioni.source.length; i++) {
          var item = self.ubicazioni.source[i];
          if (item.id == id) {
            found = true;
            self.ubicazioni.source.splice(i, 1);
            self.ubicazioni.source.push(ubicazioneTmp);
            self.ubicazioni.selected = ubicazioneTmp;
            break;
          }
        }
        if (!found) {
          // Caso di nuovo oggetto
          self.ubicazioni.source.push(ubicazioneTmp);
          self.ubicazioni.selected = ubicazioneTmp;
        }
      },
      (err) => {
        console.log(err);
        self.alertType = "error";
        self.messaggioAlert = Utils.getErrorMessage(err);
        self.showHide_alertGrid(8000);
      }
    );
  }

  disattivaUbicazioneDto(id) {
    var self = this;

    UbicazioniService.deleteUbicazione(
      self.ubicazioni.selected.id,
      (resp) => {
        console.log("deleteUbicazione");
        console.log(resp);

        if (resp.result == 1) {
          // Buon fine
          self.alertType = "success";
          self.messaggioAlert = resp.userMsg.message;
          self.showHide_alertGrid(5000);
          // Azzero l'oggetto
          self.ubicazioni.selected = null;
          // Ricarico la griglia
          self.loadUbicazioni();
          self.isEditUbicazioni = false;
        } else {
          // KO
          self.alertType = "error";
          self.messaggioAlert = resp.userMsg.message;
          self.showHide_alertDetail(5000);
        }

        self.isHidden = !self.isHidden;
        self.shouldDisable = true;
        console.log(resp.userMsg.message);
      },
      (err) => {
        console.log(err);
        self.alertType = "error";
        self.messaggioAlert = Utils.getErrorMessage(err);
        self.showHide_alertDetail(5000);
      }
    );
  }

}
</script>